import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import orderBy from 'lodash-es/orderBy'

import './index.styl'

const CatLabel = ({cat}) => {
  const stringArr = cat.trim().split(' ')
  return (
    <span>
    {
      stringArr.map((str, i) => (
        i%2 
        ? (
          <> {str}{ i !== stringArr.length -1  && <br/> }</>
        ) : str
      ))
    }
    </span>
  )
}

const SpecTable = ({ items }) => {
  const [specCats, setSpecCats] = useState([])
  const [sortBy, setSortBy] = useState({})

  const { t } =  useTranslation()

  useEffect(() => {
    const allCats = Object.keys(items[0]).filter(key => key !== 'id')

    const cats = []

    allCats.forEach(cat => {
      for (let i = 0; i < items.length; i += 1) {
        if (items[i][cat]) {
          cats.push(cat)
          break
        }
      }
    })

    const diameterCat = cats.filter(cat => cat.startsWith('Diameter'))

    setSortBy({ key: diameterCat[0] || cats[0], desc: false })
    setSpecCats(cats)
  }, [])

  const setSorting = key => {
    setSortBy({
      key,
      desc: sortBy.key === key ? !sortBy.desc : false,
    })
  }

  return (
    <div className="spec-table">
      <table className="spec-table__instance">
        <thead>
          <tr>
            {specCats.map(cat => (
              <th
                className={classNames('spec-table__th', {
                  'spec-table__th--active': cat === sortBy.key,
                  'spec-table__th--active__desc':
                    cat === sortBy.key && sortBy.desc,
                  'spec-table__th--active__asc':
                    cat === sortBy.key && !sortBy.desc,
                })}
                onClick={() => setSorting(cat)}
                key={cat}
              >
                <CatLabel cat={ process.browser ? t(`spec.${cat}`) : cat} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {orderBy(items, [sortBy.key], [sortBy.desc ? 'desc' : 'asc']).map(
            (item, i) => (
              <tr 
                key={item.id} 
                className="spec-table__tr"
                className={classNames('spec-table__tr', {
                  'spec-table__tr-even': i%2,
                })}
              >
                {specCats.map(cat => (
                  <td className="spec-table__td" key={`${item.id}-${cat}`}>
                    {item[cat]}
                  </td>
                ))}
              </tr>
            )
          )}
        </tbody>
      </table>
    </div>
  )
}

SpecTable.propTypes = {}

export default SpecTable
